import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Row, Col, Icon } from 'antd';

export default class StudentInfo extends React.Component {
  render() {
    const { t, student, payload, isHercules } = this.props;
    return (
      <div>
        <div className="longtail-booking-details__block-row-container">
          {isHercules && (
            <div className="tipbox">
              <Icon type="info-circle" style={{ color: '#6B92F3', marginRight: '8px' }} />
              <div className="tipbox__content">
                {t('landlord.long_tail.booking_details.snapshot.tips')}
              </div>
            </div>
          )}
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.passport_first_name', {
                  value: student && student.passportFirstName ? student.passportFirstName : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.gender', {
                  value:
                    student && student.gender
                      ? t(
                          `landlord.long_tail.booking_details.field.gender.${student.gender.toLowerCase()}`,
                        )
                      : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.email', {
                  value:
                    student && student.emailAddress
                      ? this.props.hiddenEmailByStatus(
                          student.emailAddress,
                          payload.stage,
                          payload.secondaryStage,
                        )
                      : '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.passport_last_name', {
                  value: student && student.passportLastName ? student.passportLastName : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.date_of_birth', {
                  value:
                    student && student.dateOfBirth
                      ? moment(student.dateOfBirth).format('DD/MM/YYYY')
                      : '-',
                })}
              </p>

              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.mobile', {
                  value:
                    student && student.phoneNumber
                      ? this.props.hiddenPhoneByStatus(
                          student.phoneNumber,
                          payload.stage,
                          payload.secondaryStage,
                        )
                      : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
        <div className="longtail-booking-details__block-row-container">
          <Row gutter={50} className="longtail-booking-details__block-row">
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.country', {
                  value: student && student.country ? student.country : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.city', {
                  value: student && student.city ? student.city : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.address', {
                  value: student && student.addressLines ? student.addressLines : '-',
                })}
              </p>
            </Col>
            <Col span={12} className="longtail-booking-details__block-col">
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.state', {
                  value: student && student.state ? student.state : '-',
                })}
              </p>
              <p className="longtail-booking-details__line">
                {t('landlord.long_tail.booking_details.label.student_info.postal', {
                  value: student && student.postalCode ? student.postalCode : '-',
                })}
              </p>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

StudentInfo.propTypes = {
  t: PropTypes.func,
  student: PropTypes.object,
  payload: PropTypes.object,
  hiddenPhoneByStatus: PropTypes.func,
  hiddenEmailByStatus: PropTypes.func,
};

StudentInfo.defaultProps = {
  t: () => {},
  student: {},
  payload: {},
  hiddenPhoneByStatus: () => {},
  hiddenEmailByStatus: () => {},
};
